import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";

export interface AuditEvent {
  id: string;
  evento: string;
  entita_tipo: string;
  entita_id: string;
  attore_id: string | null;
  valore_prima: Record<string, unknown> | null;
  valore_dopo: Record<string, unknown> | null;
  metadati: Record<string, unknown> | null;
  creato_il: string;
}

export interface AuditFilter {
  evento?: string;
  entita_tipo?: string;
  attore_id?: string;
  giorni: number;
  limit?: number;
}

export function useAdminAudit(filter: AuditFilter) {
  const params = new URLSearchParams({
    giorni: String(filter.giorni),
    limit: String(filter.limit ?? 100),
  });
  if (filter.evento) params.set("evento", filter.evento);
  if (filter.entita_tipo) params.set("entita_tipo", filter.entita_tipo);
  if (filter.attore_id) params.set("attore_id", filter.attore_id);
  return useQuery({
    queryKey: ["admin-audit", filter],
    queryFn: () => apiFetch<AuditEvent[]>(`/api/v1/admin/audit?${params.toString()}`),
    staleTime: 15_000,
  });
}
